import {inject, Injectable} from '@angular/core';
import {environment} from '@/environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Inventory, InventoryCard, SellableInventoryCard} from '@/app/core/models/inventory.model';
import {CardRarity} from '@/app/shared/components/card/card.model';
import {Page} from '@/app/core/models/page';

export interface GetInventoryCardsParams {
	page?: number;
	size?: number;
	/** Tri côté back — `rarity` respecte le palier de rareté fixe, pas l'ordre alphabétique. */
	sortBy?: 'rarity' | 'score' | 'name';
	/** Sens du champ de tri principal (`rarity` : ordre de tier métier direct/inversé). Défaut back : `desc`. */
	direction?: 'asc' | 'desc';
	rarity?: CardRarity;
	extensionId?: string;
	name?: string;
}

export interface GetSellableInventoryParams {
	page?: number;
	size?: number;
	/** `score` desc par défaut · `name` asc · `rarity` = ordre alpha DB, pas le palier de rareté. */
	sortBy?: 'score' | 'name' | 'rarity';
	rarity?: CardRarity;
	extensionId?: string;
	name?: string;
}

@Injectable({
	providedIn: 'root'
})
export class InventoryService {

	private readonly SERVICE_URI = `${environment.backendUrl}/inventory`;

	private readonly http: HttpClient = inject(HttpClient);

	getInventory(): Observable<Inventory> {
		return this.http.get<Inventory>(`${this.SERVICE_URI}`);
	}

	getInventoryCards(params: GetInventoryCardsParams = {}): Observable<Page<InventoryCard>> {
		let httpParams = new HttpParams()
			.set('page', params.page ?? 0)
			.set('size', params.size ?? 24)
			.set('sortBy', params.sortBy ?? 'rarity')
			.set('direction', params.direction ?? 'desc');
		if (params.rarity) httpParams = httpParams.set('rarity', params.rarity);
		if (params.extensionId) httpParams = httpParams.set('extensionId', params.extensionId);
		if (params.name) httpParams = httpParams.set('name', params.name);

		return this.http.get<Page<InventoryCard>>(`${this.SERVICE_URI}/cards`, {params: httpParams});
	}

	getSellableInventory(params: GetSellableInventoryParams = {}): Observable<Page<SellableInventoryCard>> {
		let httpParams = new HttpParams()
			.set('page', params.page ?? 0)
			.set('size', params.size ?? 20)
			.set('sortBy', params.sortBy ?? 'score');
		if (params.rarity) httpParams = httpParams.set('rarity', params.rarity);
		if (params.extensionId) httpParams = httpParams.set('extensionId', params.extensionId);
		if (params.name) httpParams = httpParams.set('name', params.name);

		return this.http.get<Page<SellableInventoryCard>>(`${this.SERVICE_URI}/sellable`, {params: httpParams});
	}
}
